export default __webpack_public_path__ + "static/media/kurono.ba03111d.png";